import { To } from 'history';
import { MouseEvent } from 'react';
import { Link } from 'react-router-dom';

// project import
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';
import LogoIcon from './LogoIcon';
import Logo from './LogoMain';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
    isIcon?: boolean;
    className?: string;
    to?: To;
    onClick?: () => void;
    target?: string;
    href?: string;
}

function LogoSection({ isIcon, className, to, onClick, href, target }: Props): JSX.Element {
    const classes = cn(
        'focus-visible:ring-ring/50 inline-flex items-center justify-center align-middle outline-none focus-visible:ring-3',
        className
    );
    const logo = isIcon ? <LogoIcon /> : <Logo />;

    return href && target ? (
        <a className={classes} href={href} target={target} aria-label={t('crespect-logo')}>
            {logo}
        </a>
    ) : (
        <Link
            className={classes}
            to={to ?? {}}
            aria-label={t('crespect-logo')}
            onClick={(e: MouseEvent) => {
                if (!onClick) return;
                e.preventDefault();
                onClick();
            }}
        >
            {logo}
        </Link>
    );
}
export default LogoSection;
